export default __webpack_public_path__ + "static/serial-records-GIF-c124993cc08cbe832794b41e20b7c353.gif";